import { render, staticRenderFns } from "./EventsValidationEventsList.vue?vue&type=template&id=e5b8a982"
import script from "./EventsValidationEventsList.vue?vue&type=script&lang=js"
export * from "./EventsValidationEventsList.vue?vue&type=script&lang=js"
import style0 from "./EventsValidationEventsList.vue?vue&type=style&index=0&id=e5b8a982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports